import { html } from 'lit';
import { LogOut } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-log-out')
export class PdsIconLogOut extends PdsIcon {
  @state()
  icon = LogOut;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
